angular
     .module('vppApp')
     .directive("contentCards", function() {
     	
	    return {
        restrict: 'E'
	    };
	});